// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SearchResultsPage.css - 고유한 클래스명으로 CSS 충돌 방지 */
.srp-search-results-page {
    min-height: 100vh;
    background-color: #f8f9fa;
    padding: 40px 20px;
}

.srp-search-container {
    max-width: 1200px;
    margin: 0 auto;
}

.srp-search-header {
    margin-bottom: 30px;
    padding: 20px 0;
    border-bottom: 2px solid #dee2e6;
}

.srp-search-header h1 {
    color: #212529;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 10px;
}

.srp-search-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    flex-wrap: wrap;
    color: #6c757d;
    font-size: 1.1rem;
}

.srp-search-header-right {
    display: flex;
    align-items: center;
    gap: 20px;
}

.srp-items-per-page-selector {
    display: flex;
    align-items: center;
    gap: 8px;
}

.srp-items-per-page-selector label {
    font-size: 14px;
    color: #666;
}

.srp-items-per-page-select {
    padding: 6px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    background-color: #fff;
    cursor: pointer;
    transition: border-color 0.2s ease;
}

.srp-items-per-page-select:hover {
    border-color: #E84100;
}

.srp-items-per-page-select:focus {
    outline: 2px solid #E84100;
    outline-offset: 2px;
    border-color: #E84100;
}

.srp-search-query {
    color: #E84100;
    font-weight: 600;
}

.srp-search-count {
    background-color: #E84100;
    color: white;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 0.9rem;
    font-weight: 600;
}

/* Grid Layout */
.srp-search-results-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 25px;
    margin-top: 20px;
}

/* Product Card */
.srp-search-product-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    transition: all 0.3s ease;
    border: 1px solid #e9ecef;
}

.srp-search-product-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.srp-search-product-image-container {
    width: 100%;
    height: 200px;
    overflow: hidden;
    cursor: pointer;
    position: relative;
    background-color: #f8f9fa;
}

.srp-search-product-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.srp-search-product-image-container:hover .srp-search-product-image {
    transform: scale(1.05);
}

.srp-search-product-info {
    padding: 20px;
    flex-grow: 1;
}

.srp-search-product-name {
    font-size: 1.3rem;
    font-weight: 600;
    color: #212529;
    margin-bottom: 8px;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.srp-search-product-description {
    color: #6c757d;
    font-size: 0.95rem;
    line-height: 1.5;
    margin-bottom: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.srp-search-product-category {
    background-color: #f8f9fa;
    color: #495057;
    padding: 4px 10px;
    border-radius: 15px;
    font-size: 0.85rem;
    font-weight: 500;
    display: inline-block;
    margin-bottom: 12px;
}

.srp-search-product-price {
    margin-bottom: 8px;
}

.srp-search-product-current-price {
    font-size: 1.4rem;
    font-weight: 700;
    color: #E84100;
}

.srp-search-product-original-price {
    font-size: 1rem;
    color: #6c757d;
    text-decoration: line-through;
    margin-right: 8px;
}

.srp-search-product-discount-price {
    font-size: 1.4rem;
    font-weight: 700;
    color: #dc3545;
}

.srp-search-product-stock {
    font-size: 0.9rem;
    color: #28a745;
    font-weight: 500;
    margin-bottom: 15px;
}

.srp-search-product-actions {
    padding: 0 20px 20px;
}

.srp-search-cart-button {
    width: 100%;
    background-color: #E84100;
    color: white;
    border: none;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.srp-search-cart-button:hover:not(:disabled) {
    background-color: #d73502;
    transform: translateY(-2px);
}

.srp-search-cart-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    transform: none;
}

/* Loading and Error States */
.srp-loading-message,
.srp-error-message,
.srp-no-query-message {
    text-align: center;
    padding: 60px 20px;
    font-size: 1.2rem;
    color: #6c757d;
}

.srp-error-message {
    color: #dc3545;
}

/* No Results */
.srp-no-results {
    text-align: center;
    padding: 60px 20px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.srp-no-results h2 {
    color: #212529;
    font-size: 2rem;
    margin-bottom: 15px;
}

.srp-no-results p {
    color: #6c757d;
    font-size: 1.1rem;
    margin-bottom: 30px;
}

.srp-search-suggestions {
    max-width: 400px;
    margin: 0 auto;
    text-align: left;
}

.srp-search-suggestions h3 {
    color: #495057;
    font-size: 1.2rem;
    margin-bottom: 15px;
    text-align: center;
}

.srp-search-suggestions ul {
    list-style: none;
    padding: 0;
}

.srp-search-suggestions li {
    color: #6c757d;
    padding: 8px 0;
    border-bottom: 1px solid #e9ecef;
    position: relative;
    padding-left: 20px;
}

.srp-search-suggestions li:before {
    content: "•";
    color: #E84100;
    font-weight: bold;
    position: absolute;
    left: 0;
}

.srp-search-suggestions li:last-child {
    border-bottom: none;
}

/* Responsive Design */
@media (max-width: 768px) {
    .srp-search-results-page {
        padding: 20px 10px;
    }
    
    .srp-search-header h1 {
        font-size: 2rem;
    }
    
    .srp-search-info {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
    
    .srp-search-results-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }
    
    .srp-search-product-card {
        margin: 0 5px;
    }
}

@media (max-width: 480px) {
    .srp-search-header h1 {
        font-size: 1.5rem;
    }
    
    .srp-search-product-name {
        font-size: 1.1rem;
    }
    
    .srp-search-product-current-price,
    .srp-search-product-discount-price {
        font-size: 1.2rem;
    }
}

/* 페이지네이션 스타일 */
.srp-pagination-container {
    margin-top: 40px;
    padding-top: 30px;
    border-top: 1px solid #eee;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.srp-pagination {
    display: flex;
    align-items: center;
    gap: 5px;
}

.srp-pagination-btn {
    min-width: 36px;
    height: 36px;
    padding: 0 12px;
    border: 1px solid #ddd;
    background-color: #fff;
    border-radius: 4px;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.srp-pagination-btn:hover:not(:disabled) {
    background-color: #E84100;
    border-color: #E84100;
    color: #fff;
}

.srp-pagination-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    background-color: #f5f5f5;
}

.srp-pagination-numbers {
    display: flex;
    align-items: center;
    gap: 5px;
}

.srp-pagination-number {
    min-width: 36px;
    height: 36px;
    padding: 0 8px;
    border: 1px solid #ddd;
    background-color: #fff;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.srp-pagination-number:hover {
    background-color: #f5f5f5;
    border-color: #E84100;
    color: #E84100;
}

.srp-pagination-number.active {
    background-color: #E84100;
    border-color: #E84100;
    color: #fff;
    font-weight: bold;
}

.srp-pagination-number.active:hover {
    background-color: #d63900;
    border-color: #d63900;
}

.srp-pagination-ellipsis {
    padding: 0 8px;
    color: #999;
    font-size: 14px;
}

.srp-pagination-info {
    font-size: 14px;
    color: #666;
}

/* 모바일 페이지네이션 */
@media (max-width: 768px) {
    .srp-search-info {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .srp-search-header-right {
        width: 100%;
        justify-content: space-between;
    }
    
    .srp-pagination-container {
        margin-top: 30px;
        padding-top: 20px;
    }
    
    .srp-pagination {
        flex-wrap: wrap;
        justify-content: center;
        gap: 3px;
    }
    
    .srp-pagination-btn,
    .srp-pagination-number {
        min-width: 32px;
        height: 32px;
        font-size: 13px;
        padding: 0 6px;
    }
    
    .srp-pagination-numbers {
        gap: 3px;
    }
    
    .srp-pagination-info {
        font-size: 12px;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/SearchResultsPage.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA,6BAA6B;AAC7B;;;IAGI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,iBAAiB;IACrB;AACJ;;AAEA,eAAe;AACf;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;;QAEI,eAAe;QACf,YAAY;QACZ,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* SearchResultsPage.css - 고유한 클래스명으로 CSS 충돌 방지 */\n.srp-search-results-page {\n    min-height: 100vh;\n    background-color: #f8f9fa;\n    padding: 40px 20px;\n}\n\n.srp-search-container {\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.srp-search-header {\n    margin-bottom: 30px;\n    padding: 20px 0;\n    border-bottom: 2px solid #dee2e6;\n}\n\n.srp-search-header h1 {\n    color: #212529;\n    font-size: 2.5rem;\n    font-weight: 700;\n    margin-bottom: 10px;\n}\n\n.srp-search-info {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 15px;\n    flex-wrap: wrap;\n    color: #6c757d;\n    font-size: 1.1rem;\n}\n\n.srp-search-header-right {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.srp-items-per-page-selector {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.srp-items-per-page-selector label {\n    font-size: 14px;\n    color: #666;\n}\n\n.srp-items-per-page-select {\n    padding: 6px 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n    background-color: #fff;\n    cursor: pointer;\n    transition: border-color 0.2s ease;\n}\n\n.srp-items-per-page-select:hover {\n    border-color: #E84100;\n}\n\n.srp-items-per-page-select:focus {\n    outline: 2px solid #E84100;\n    outline-offset: 2px;\n    border-color: #E84100;\n}\n\n.srp-search-query {\n    color: #E84100;\n    font-weight: 600;\n}\n\n.srp-search-count {\n    background-color: #E84100;\n    color: white;\n    padding: 4px 12px;\n    border-radius: 20px;\n    font-size: 0.9rem;\n    font-weight: 600;\n}\n\n/* Grid Layout */\n.srp-search-results-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n    gap: 25px;\n    margin-top: 20px;\n}\n\n/* Product Card */\n.srp-search-product-card {\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n    overflow: hidden;\n    transition: all 0.3s ease;\n    border: 1px solid #e9ecef;\n}\n\n.srp-search-product-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n}\n\n.srp-search-product-image-container {\n    width: 100%;\n    height: 200px;\n    overflow: hidden;\n    cursor: pointer;\n    position: relative;\n    background-color: #f8f9fa;\n}\n\n.srp-search-product-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.3s ease;\n}\n\n.srp-search-product-image-container:hover .srp-search-product-image {\n    transform: scale(1.05);\n}\n\n.srp-search-product-info {\n    padding: 20px;\n    flex-grow: 1;\n}\n\n.srp-search-product-name {\n    font-size: 1.3rem;\n    font-weight: 600;\n    color: #212529;\n    margin-bottom: 8px;\n    line-height: 1.4;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.srp-search-product-description {\n    color: #6c757d;\n    font-size: 0.95rem;\n    line-height: 1.5;\n    margin-bottom: 12px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.srp-search-product-category {\n    background-color: #f8f9fa;\n    color: #495057;\n    padding: 4px 10px;\n    border-radius: 15px;\n    font-size: 0.85rem;\n    font-weight: 500;\n    display: inline-block;\n    margin-bottom: 12px;\n}\n\n.srp-search-product-price {\n    margin-bottom: 8px;\n}\n\n.srp-search-product-current-price {\n    font-size: 1.4rem;\n    font-weight: 700;\n    color: #E84100;\n}\n\n.srp-search-product-original-price {\n    font-size: 1rem;\n    color: #6c757d;\n    text-decoration: line-through;\n    margin-right: 8px;\n}\n\n.srp-search-product-discount-price {\n    font-size: 1.4rem;\n    font-weight: 700;\n    color: #dc3545;\n}\n\n.srp-search-product-stock {\n    font-size: 0.9rem;\n    color: #28a745;\n    font-weight: 500;\n    margin-bottom: 15px;\n}\n\n.srp-search-product-actions {\n    padding: 0 20px 20px;\n}\n\n.srp-search-cart-button {\n    width: 100%;\n    background-color: #E84100;\n    color: white;\n    border: none;\n    padding: 12px 16px;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.srp-search-cart-button:hover:not(:disabled) {\n    background-color: #d73502;\n    transform: translateY(-2px);\n}\n\n.srp-search-cart-button:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n    transform: none;\n}\n\n/* Loading and Error States */\n.srp-loading-message,\n.srp-error-message,\n.srp-no-query-message {\n    text-align: center;\n    padding: 60px 20px;\n    font-size: 1.2rem;\n    color: #6c757d;\n}\n\n.srp-error-message {\n    color: #dc3545;\n}\n\n/* No Results */\n.srp-no-results {\n    text-align: center;\n    padding: 60px 20px;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.srp-no-results h2 {\n    color: #212529;\n    font-size: 2rem;\n    margin-bottom: 15px;\n}\n\n.srp-no-results p {\n    color: #6c757d;\n    font-size: 1.1rem;\n    margin-bottom: 30px;\n}\n\n.srp-search-suggestions {\n    max-width: 400px;\n    margin: 0 auto;\n    text-align: left;\n}\n\n.srp-search-suggestions h3 {\n    color: #495057;\n    font-size: 1.2rem;\n    margin-bottom: 15px;\n    text-align: center;\n}\n\n.srp-search-suggestions ul {\n    list-style: none;\n    padding: 0;\n}\n\n.srp-search-suggestions li {\n    color: #6c757d;\n    padding: 8px 0;\n    border-bottom: 1px solid #e9ecef;\n    position: relative;\n    padding-left: 20px;\n}\n\n.srp-search-suggestions li:before {\n    content: \"•\";\n    color: #E84100;\n    font-weight: bold;\n    position: absolute;\n    left: 0;\n}\n\n.srp-search-suggestions li:last-child {\n    border-bottom: none;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .srp-search-results-page {\n        padding: 20px 10px;\n    }\n    \n    .srp-search-header h1 {\n        font-size: 2rem;\n    }\n    \n    .srp-search-info {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n    \n    .srp-search-results-grid {\n        grid-template-columns: 1fr;\n        gap: 20px;\n    }\n    \n    .srp-search-product-card {\n        margin: 0 5px;\n    }\n}\n\n@media (max-width: 480px) {\n    .srp-search-header h1 {\n        font-size: 1.5rem;\n    }\n    \n    .srp-search-product-name {\n        font-size: 1.1rem;\n    }\n    \n    .srp-search-product-current-price,\n    .srp-search-product-discount-price {\n        font-size: 1.2rem;\n    }\n}\n\n/* 페이지네이션 스타일 */\n.srp-pagination-container {\n    margin-top: 40px;\n    padding-top: 30px;\n    border-top: 1px solid #eee;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n}\n\n.srp-pagination {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.srp-pagination-btn {\n    min-width: 36px;\n    height: 36px;\n    padding: 0 12px;\n    border: 1px solid #ddd;\n    background-color: #fff;\n    border-radius: 4px;\n    font-size: 18px;\n    font-weight: bold;\n    color: #333;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.srp-pagination-btn:hover:not(:disabled) {\n    background-color: #E84100;\n    border-color: #E84100;\n    color: #fff;\n}\n\n.srp-pagination-btn:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n    background-color: #f5f5f5;\n}\n\n.srp-pagination-numbers {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.srp-pagination-number {\n    min-width: 36px;\n    height: 36px;\n    padding: 0 8px;\n    border: 1px solid #ddd;\n    background-color: #fff;\n    border-radius: 4px;\n    font-size: 14px;\n    color: #333;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.srp-pagination-number:hover {\n    background-color: #f5f5f5;\n    border-color: #E84100;\n    color: #E84100;\n}\n\n.srp-pagination-number.active {\n    background-color: #E84100;\n    border-color: #E84100;\n    color: #fff;\n    font-weight: bold;\n}\n\n.srp-pagination-number.active:hover {\n    background-color: #d63900;\n    border-color: #d63900;\n}\n\n.srp-pagination-ellipsis {\n    padding: 0 8px;\n    color: #999;\n    font-size: 14px;\n}\n\n.srp-pagination-info {\n    font-size: 14px;\n    color: #666;\n}\n\n/* 모바일 페이지네이션 */\n@media (max-width: 768px) {\n    .srp-search-info {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n    \n    .srp-search-header-right {\n        width: 100%;\n        justify-content: space-between;\n    }\n    \n    .srp-pagination-container {\n        margin-top: 30px;\n        padding-top: 20px;\n    }\n    \n    .srp-pagination {\n        flex-wrap: wrap;\n        justify-content: center;\n        gap: 3px;\n    }\n    \n    .srp-pagination-btn,\n    .srp-pagination-number {\n        min-width: 32px;\n        height: 32px;\n        font-size: 13px;\n        padding: 0 6px;\n    }\n    \n    .srp-pagination-numbers {\n        gap: 3px;\n    }\n    \n    .srp-pagination-info {\n        font-size: 12px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
